<div class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm">
  <div class="relative">
    <app-slideshow
      [galleryClicked]="false"
      [images]="images()"
      (openGalleryClicked)="openGalleryClicked.emit($event)"
      [(selected)]="selectedImage"
    >
      @if (listing().youtubeId) {
        <button
          id="tour-button"
          type="button"
          class="rounded-md px-2.5 py-1.5 text-sm sm:text-xs font-semibold bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-900 cursor-pointer dark:disabled:bg-gray-800/20 flex items-center gap-1"
          (click)="openTourClicked.emit()"
        >
          <svg
            viewBox="0 -960 960 960"
            class="fill-gray-900 dark:fill-gray-100 h-7 w-7"
            aria-hidden="true"
          >
            <path
              d="M460-398.46 711.54-560 460-721.54v323.08ZM322.31-260Q292-260 271-281q-21-21-21-51.31v-455.38Q250-818 271-839q21-21 51.31-21h455.38Q808-860 829-839q21 21 21 51.31v455.38Q850-302 829-281q-21 21-51.31 21H322.31Zm0-60h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H322.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85Zm-140 200Q152-120 131-141q-21-21-21-51.31v-515.38h60v515.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h515.38v60H182.31ZM310-800v480-480Z"
            />
          </svg>

          Tour
        </button>
      }
    </app-slideshow>

    <div class="absolute top-0 left-0 flex gap-1 p-2 flex-wrap">
      @if (openNow() || listing().openTomorrow) {
        <app-listing-details-open-house
          [listing]="listing()"
          [openNow]="openNow()"
          class="flex gap-1"
        />
      }

      <app-home-listing-card-features [listing]="listing()" class="flex gap-1" />
    </div>
  </div>

  <div class="px-4 py-5 sm:px-6 sm:py-6">
    <div class="flex gap-4 justify-between">
      <app-listing-details-info [listing]="listing()" class="min-w-0" />

      <div class="hidden lg:flex flex-col items-end gap-4 shrink-0">
        <app-listing-details-features class="hidden lg:block" [listing]="listing()" />

        <div class="flex" [style.gap]="'calc(var(--spacing) * 2)'">
          <button
            type="button"
            aria-label="View map"
            data-gtm-section="hero"
            class="bg-primary-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-primary-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 cursor-pointer rounded-md flex items-center gap-1"
            (click)="openMapClicked.emit()"
          >
            <svg viewBox="0 -960 960 960" class="fill-white h-7 w-7" aria-hidden="true">
              <path
                d="M600.77-126.92 359.23-213.08l-174.38 67.31Q165.46-137.85 150-149.96q-15.46-12.12-15.46-33.5v-539.08q0-14.54 8.65-26.19 8.66-11.65 22.43-16.19L360-833.08l241.54 86.16 174.38-67.31q19.39-7.92 34.85 4.19 15.46 12.12 15.46 33.5v539.08q0 14.54-8.65 26.19-8.66 11.65-22.43 16.19L600.77-126.92ZM570-215.38v-472.47l-180-64.3v472.46l180 64.31Zm60 1.53 150-53.07v-477.39l-150 56.93v473.53Zm-390-19.3 150-56.93v-473.54l-150 53.08v477.39Zm390-454.23v473.53-473.53Zm-390-0.16v477.39-477.39Z"
              />
            </svg>
            Map
          </button>

          @if (download()) {
            <button
              type="button"
              aria-label="Download flyer"
              class="bg-primary-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-primary-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 cursor-pointer rounded-md flex items-center gap-1"
              (click)="openDownload()"
            >
              <svg viewBox="0 -960 960 960" class="fill-white h-7 w-7" aria-hidden="true">
                <path
                  d="M720-134.23 865.77-280 824-321.77l-74 74V-429h-60v181.23l-74-74L574.23-280 720-134.23ZM570-10v-60h300v60H570ZM242.31-170q-29.54 0-50.92-21.39Q170-212.77 170-242.31v-555.38q0-29.54 21.39-50.92Q212.77-870 242.31-870H520l230 230v123.31h-60V-610H490v-200H242.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v555.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h240v60h-240ZM230-230v-580 580Z"
                />
              </svg>

              @if (listing().saleType === 'preowned') {
                Flyer
              } @else {
                Floor Plan
              }
            </button>
          }
        </div>
      </div>
    </div>

    <!-- Buttons: mobile only, left-aligned below listing info -->
    <div class="flex lg:hidden mt-3" [style.gap]="'calc(var(--spacing) * 2)'">
      <button
        type="button"
        aria-label="View map"
        data-gtm-section="hero"
        class="bg-primary-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-primary-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 cursor-pointer rounded-md flex items-center gap-1"
        (click)="openMapClicked.emit()"
      >
        <svg viewBox="0 -960 960 960" class="fill-white h-7 w-7" aria-hidden="true">
          <path
            d="M600.77-126.92 359.23-213.08l-174.38 67.31Q165.46-137.85 150-149.96q-15.46-12.12-15.46-33.5v-539.08q0-14.54 8.65-26.19 8.66-11.65 22.43-16.19L360-833.08l241.54 86.16 174.38-67.31q19.39-7.92 34.85 4.19 15.46 12.12 15.46 33.5v539.08q0 14.54-8.65 26.19-8.66 11.65-22.43 16.19L600.77-126.92ZM570-215.38v-472.47l-180-64.3v472.46l180 64.31Zm60 1.53 150-53.07v-477.39l-150 56.93v473.53Zm-390-19.3 150-56.93v-473.54l-150 53.08v477.39Zm390-454.23v473.53-473.53Zm-390-0.16v477.39-477.39Z"
          />
        </svg>
        Map
      </button>

      @if (download()) {
        <button
          type="button"
          aria-label="Download flyer"
          class="bg-primary-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-primary-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 cursor-pointer rounded-md flex items-center gap-1"
          (click)="openDownload()"
        >
          <svg viewBox="0 -960 960 960" class="fill-white h-7 w-7" aria-hidden="true">
            <path
              d="M720-134.23 865.77-280 824-321.77l-74 74V-429h-60v181.23l-74-74L574.23-280 720-134.23ZM570-10v-60h300v60H570ZM242.31-170q-29.54 0-50.92-21.39Q170-212.77 170-242.31v-555.38q0-29.54 21.39-50.92Q212.77-870 242.31-870H520l230 230v123.31h-60V-610H490v-200H242.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v555.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h240v60h-240ZM230-230v-580 580Z"
            />
          </svg>

          @if (listing().saleType === 'preowned') {
            Flyer
          } @else {
            Floor Plan
          }
        </button>
      }
    </div>

    <!-- <div class="flex gap-1 mt-2 flex-wrap justify-between items-center">
      <div class="flex gap-1 flex-wrap">
        <app-home-listing-card-features [listing]="listing()" class="flex gap-1" />
      </div>
    </div> -->

    <div
      aria-hidden="true"
      class="w-full border-t border-gray-200 dark:border-gray-700 mt-6 mb-4"
    ></div>

    <app-listing-details-actions
      [listing]="listing()"
      [listingSaved]="listing().savedItemId ? true : false"
    />

    @if (listing().description) {
      <div
        aria-hidden="true"
        class="w-full border-t border-gray-200 dark:border-gray-700 mt-4 mb-4"
      ></div>

      <div [innerHTML]="listing().description"></div>
    }
  </div>
</div>

@if (listing().features) {
  <app-listing-details-features-details [listing]="listing()" />
}

@if (listing().series?.description) {
  <app-listing-details-series-details [listing]="listing()" />
}

@if (stateService.community() !== 'middleton' && listing().village.description) {
  <app-listing-details-village-details [listing]="listing()" />
}
